import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import Button from "../../../../../../../../../components/shared/Button";
import { cn } from "../../../../../../../../../lib/utils";

function RemoveButton({ loading, onClick, size }: { loading: boolean, onClick: () => void, size?: "default" | "lg" }) {
    const { t } = useTranslation();

    return (
        <Button
            type="button"
            variant="outline"
            size="icon"
            tooltip={t("delete")}
            disabled={loading}
            onClick={onClick}
            className={cn(
                size === "lg" && "tw-h-10 tw-w-10",
                loading
                    ? "tw-border-neutral-600 tw-text-neutral-600"
                    : "tw-border-rose-700 tw-text-rose-700 hover:tw-bg-rose-50 hover:tw-text-rose-700"
            )}
        >
            <Trash2 size={18} />
        </Button>
    );
}

export default RemoveButton;
